module.exports = __webpack_public_path__ + "static/media/incoming_call.8ccaf53b.mp3";